"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uid = void 0;
var uid = function () { return Date.now().toString(36) + Math.random().toString(36).substr(2); };
exports.uid = uid;
